@import "config";

.tagLabel {
	border-radius: 9999px; // Using a high value to guarantee the tablet's shape, regardless of the content size or shape, e.g., rectangular.
	text-transform: uppercase;
	padding: 0 spacing("spacing-2x");
	font-weight: $font-weight-bold;
	font-size: $font-size-xxxs;
	margin: spacing("spacing-2x") 0;
	width: max-content;
	white-space: nowrap;
	flex-shrink: 0;
}

.warning {
	background: color("surface", "warning");
	color: color("text", "warning");
}

.pending {
	background: color("surface", "warning");
	color: color("text", "warning");
	font-weight: $font-weight-bold;
}

.paid {
	background: color("surface", "success");
	color: color("text", "success");
	font-weight: $font-weight-bold;
}

.success {
	background-color: color("surface", "success");
	color: color("text", "success");
}

.error {
	background-color: color("surface", "danger");
	color: color("text", "danger");
}

.info {
	background-color: color("surface", "callout-low-con");
	color: color("text", "label-default");
}

.primary {
	background-color: color("surface", "callout-primary");
	color: color("text", "on-contrast-primary");
}

.secondary {
	background-color: color("surface", "callout-secondary");
	color: color("text", "on-contrast-tertiary");
}

.highlight {
	background-color: color("surface", "callout-highlight");
	color: color("text", "on-contrast-highlight");
}
